import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("更新客户列表")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("批量删除")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("更新")

import { ref, computed, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import eptBtn from '@/components/ExportButton.vue'
import tbMix from '@/global_mixin/tableMixin'
import payMap from '@/views/typeMapping/PaymentModuleUtils'
import { formatTime, formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 科目余额_条件查询
  'GET/order/receivable/balances': fetchList,
  // 导出科目余额
  'GET/order/receivable/balance/export': exportApi,
  // 导入科目余额
  'POST/order/receivable/balance/import': importApi,
  // 依据科目余额更新客户列表
  'GET/order/receivable/clients/update': updateApi,
  // 科目余额更新(行内)
  'POST/order/receivable/balances/update': balancesUpdateApi,
  // 批量删除科目余额
  'DELETE/order/receivable/balances/del': delApi,
} = Api
let { currencyOption } = payMap 

const seleRows = ref<{id: number}[]>([])
const searchConfig = ref([
  {
    label: '公司',
    value: '',
    upKey: 'company',
  },
  {
    label: '客户ID',
    value: '',
    upKey: 'customer',
  }
])

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height 
} = new tbMix(fetchList)
fetchData()

const updataHandle = async() => {
  MI_identify.value = true
  await updateApi()
  try {
    ElMessage.success('更新成功')
    MI_identify.value = false
    fetchData(MI_params)
  } catch (error) {
    MI_identify.value = false
  }
}

// 更新行内科目余额
const updataFg = ref<boolean>(false)
const updataConfig = ref([
  {
    label: '客户ID',
    value: '',
    upKey: 'client',
  },
  {
    label: '客户',
    value: '',
    upKey: 'clientUsername',
  },
  {
    label: '公司',
    value: '',
    upKey: 'invoiceCompany',
  },
  {
    type: 'SELECT',
    label: '币种',
    value: '',
    upKey: 'currency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    label: '借方',
    value: '',
    upKey: 'debit',
  },
  {
    label: '贷方',
    value: '',
    upKey: 'credit',
  },
  {
    type: "TIME",
    label: "余额时间",
    value: '',
    upKey: 'computingDate',
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
])
const updataRowHandle = (row: any) => {
  MI_modifyForm(row, updataConfig, updataFg, async (params: any) => {
    await balancesUpdateApi({...params, id: row.id})
    ElMessage.success('修改成功')
    updataFg.value = false
    fetchData(MI_params)
  })
}

// 批量删除
const batchDel = () => {
  ElMessageBox.confirm('请确认是否删除', '提示').then(() => {
    MI_identify.value = true
    return delApi({ids: seleRows.value.map(row => row.id)})
  }).then(() => { 
    MI_identify.value = false
    ElMessage.success('删除成功')
    fetchData(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "收款-科目余额-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (updataHandle())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives(_createVNode(_component_TheUpBtn, {
      showBtn: true,
      upParams: {},
      upText: '导入科目余额',
      upFetch: _unref(importApi),
      onUpSuccess: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
    }, null, 8, ["upFetch"]), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives(_createVNode(eptBtn, {
      exportFn: _unref(exportApi),
      exportText: '导出科目余额',
      disabled: _unref(MI_identify)
    }, null, 8, ["exportFn", "disabled"]), [
      [_directive_permission, 'Export']
    ]),
    _createVNode(_component_el_button, {
      type: "danger",
      onClick: batchDel,
      disabled: _unref(MI_identify) || seleRows.value.length === 0
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      class: "mt-10",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 40 + 'px',
      onSelectionChange: _cache[2] || (_cache[2] = (rows) => seleRows.value = rows)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          width: "55",
          type: "selection"
        }),
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "client",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户",
          prop: "clientUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "invoiceCompany",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency"
        }),
        _createVNode(_component_el_table_column, {
          label: "借方",
          prop: "debit",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "贷方",
          prop: "credit",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "余额时间",
          prop: "computingDate",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createdTime",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "90"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              onClick: ($event: any) => (updataRowHandle(row)),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      disabled: _unref(MI_identify),
      "page-sizes": [30, 50, 100, 300],
      class: "mt-10",
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "更新",
      modelValue: updataFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((updataFg).value = $event))
    }, {
      default: _withCtx(() => [
        (updataFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: updataConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})